export default "/images/avatar-1.jpg?3921191a8acf79d3e9071759f4f0489c";